import React from "react";

const CaptainSearchStyles = () => {
  return (
    <style>
      {`
        @keyframes acceptedPulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.35);
          }
          50% {
            transform: scale(1.08);
            box-shadow: 0 0 0 14px rgba(34, 197, 94, 0);
          }
        }

        .driver-accepted-pulse {
          animation: acceptedPulse 1.4s ease-in-out infinite;
        }

        @keyframes vehicleMoveUpDown {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-16px);
          }
        }

        @keyframes vehicleMoveLeftRight {
          0%, 100% {
            transform: translateX(0px);
          }
          50% {
            transform: translateX(18px);
          }
        }

        @keyframes vehicleMoveDiagonalOne {
          0%, 100% {
            transform: translate(0px, 0px);
          }
          50% {
            transform: translate(14px, -14px);
          }
        }

        @keyframes vehicleMoveDiagonalTwo {
          0%, 100% {
            transform: translate(0px, 0px);
          }
          50% {
            transform: translate(-14px, 14px);
          }
        }

        @keyframes vehicleFloatPulse {
          0%, 100% {
            scale: 1;
          }
          50% {
            scale: 1.08;
          }
        }

        .map-vehicle-marker {
          position: absolute;
          width: 42px;
          height: 42px;
          transform: translate(-50%, -50%);
          pointer-events: auto;
          cursor: pointer;
          z-index: 20;
        }

        .map-vehicle-marker-inner {
          width: 42px;
          height: 42px;
          border-radius: 999px;
          display: flex;
          align-items: center;
          justify-content: center;
          animation: vehicleFloatPulse 1.6s ease-in-out infinite;
        }

        .map-vehicle-marker-inner img {
          width: 31px;
          height: 31px;
          object-fit: contain;
        }

        .vehicle-animate-up-down {
          animation: vehicleMoveUpDown 2.4s ease-in-out infinite;
        }

        .vehicle-animate-left-right {
          animation: vehicleMoveLeftRight 2.7s ease-in-out infinite;
        }

        .vehicle-animate-diagonal-one {
          animation: vehicleMoveDiagonalOne 3s ease-in-out infinite;
        }

        .vehicle-animate-diagonal-two {
          animation: vehicleMoveDiagonalTwo 3.2s ease-in-out infinite;
        }

        .vehicle-accepted {
          z-index: 50;
        }

        .vehicle-dimmed {
          opacity: 0.35;
        }

        @keyframes radiusWavePulse {
          0% {
            transform: scale(0.08);
            opacity: 0.85;
            border-width: 8px;
            box-shadow:
              0 0 18px rgba(37, 99, 235, 0.5),
              inset 0 0 22px rgba(37, 99, 235, 0.18);
          }

          45% {
            opacity: 0.45;
            border-width: 5px;
            box-shadow:
              0 0 22px rgba(37, 99, 235, 0.32),
              inset 0 0 20px rgba(37, 99, 235, 0.12);
          }

          75% {
            opacity: 0.18;
            border-width: 3px;
            box-shadow:
              0 0 16px rgba(37, 99, 235, 0.16),
              inset 0 0 12px rgba(37, 99, 235, 0.07);
          }

          100% {
            transform: scale(1);
            opacity: 0;
            border-width: 1px;
            box-shadow:
              0 0 0 rgba(37, 99, 235, 0),
              inset 0 0 0 rgba(37, 99, 235, 0);
          }
        }

        .radius-wave-overlay {
          position: absolute;
          pointer-events: none;
          border-radius: 9999px;
          transform-origin: center;
          z-index: 2;
        }

        .radius-wave-ring {
          position: absolute;
          inset: 0;
          border-radius: 9999px;
          border-style: solid;
          border-color: rgba(37, 99, 235, 0.55);
          background: radial-gradient(
            circle,
            rgba(37, 99, 235, 0.18) 0%,
            rgba(37, 99, 235, 0.1) 28%,
            rgba(37, 99, 235, 0.04) 58%,
            rgba(37, 99, 235, 0) 100%
          );
          animation: radiusWavePulse 2.8s ease-out infinite;
        }

        .radius-wave-ring-1 {
          animation-delay: 0s;
        }

        .radius-wave-ring-2 {
          animation-delay: 0.9s;
        }

        .radius-wave-ring-3 {
          animation-delay: 1.8s;
        }
      `}
    </style>
  );
};

export default CaptainSearchStyles;